import { Component, inject } from '@angular/core';
import { JourneyStepTrackerService } from '@common';

@Component({
  selector: 'app-progression-steps',
  templateUrl: './progression-steps.component.html',
  styleUrl: './progression-steps.component.scss',
})
export class ProgressionStepsComponent {
  private readonly journeyStepTracker = inject(JourneyStepTrackerService);

  readonly stepInfo = this.journeyStepTracker.stepInfo;
  readonly currentStepWithPageName =
    this.journeyStepTracker.currentStepWithPageName;
}
